import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import ExportedCubeJson from '../360_react/ExportedCubeJson';
import Scene360 from '../360_react/Scene360';
import Scene360Layer from '../360_react/Scene360Layer';
import Scene360LayerChoice from '../360_react/Scene360LayerChoice';
import HotspotType from '../enums/HotspotType';
import HotspotOutside360Move from './HotspotOutside360Move';
import HotspotOutside360Configurator from './HotspotOutside360Configurator';
import HotspotOutside360Info from './HotspotOutside360Info';
import AssetsManager from '../assets_management/AssetsManager';
import Urls from '../urls/Urls';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonOutside360Scene{
	constructor(props){
		const{exportedCubeJson, hotspots, uniqueId, configuratorHotspots, cameraEulerAngles}=props;
		if(exportedCubeJson===undefined||exportedCubeJson===null)
			throwNotProvided('exportedCubeJson');
		this._exportedCubeJson = exportedCubeJson;
		if(hotspots===undefined||hotspots===null)
			throwNotProvided('hotspots');
		this._hotspots = hotspots;
		if(configuratorHotspots===undefined||configuratorHotspots===null)
			throwNotProvided('configuratorHotspots');
		this._configuratorHotspots = configuratorHotspots;
		if(uniqueId===undefined||uniqueId===null)
			throwNotProvided('uniqueId');
		this._uniqueId= uniqueId;
		this._cameraEulerAngles = cameraEulerAngles;
	}
	get exportedCubeJson(){
		return this._exportedCubeJson;
	}
	get hotspots(){
		return this._hotspots;
	}
	get configuratorHotspots(){
		return this._configuratorHotspots;
	}
	get uniqueId(){
		return this._uniqueId;
	}
	get cameraEulerAngles(){
		return this._cameraEulerAngles;
	}
	static fromJSON(jObjectOutside360Scene, getPlotByNumber, configuration){
		const configuratorHotspots =[];
		return new SiteJsonOutside360Scene({exportedCubeJson:ExportedCubeJson.fromJSON(jObjectOutside360Scene.exportedCube), 
		hotspots:SiteJsonOutside360Scene._hotspotsFromJSON(jObjectOutside360Scene.hotspots, configuratorHotspots, 
		getPlotByNumber, configuration),
		uniqueId:jObjectOutside360Scene.uniqueId,
		configuratorHotspots:configuratorHotspots,
		cameraEulerAngles:jObjectOutside360Scene.cameraEulerAngles});
	}
	static _hotspotsFromJSON(jArrayHotspots, configuratorHotspots, getPlotByNumber, configuration){
		const hotspots = [];
		for(var i=0; i<jArrayHotspots.length; i++){
			try{
				const jObjectHotspot = jArrayHotspots[i];
				let hotspot;
				switch(jObjectHotspot.type){
					case HotspotType.OUTSIDE_360_MOVE:
						hotspot = HotspotOutside360Move.fromJSON(jObjectHotspot);
						break;
					case HotspotType.INFO:
						hotspot = HotspotOutside360Info.fromJSON(jObjectHotspot);
						break;
					case HotspotType.OUTSIDE_360_CONFIGURATOR:
						hotspot = HotspotOutside360Configurator.fromJSON(jObjectHotspot, getPlotByNumber, configuration);
						configuratorHotspots.push(hotspot);
						break;
					default:
						throw new Error(`Not implemented for HotspotType ${jObjectHotspot.type}`);
				}
				hotspots.push(hotspot);
			}
			catch(e){
				throw new Error(`While parsing hotspots[${i}]`+e?.stack);
			}
		}
		return hotspots;
	}
}